import {IInsideOrbitMenuActionInterface} from "../interface/inside-orbit-menu-action.interface";
import {IInsideOrbitMenuServices} from "../../../../services/inside-orbit-menu-services/inside-orbit-menu.service.interface";
import {CLEAR_LOCAL_STORAGE} from "../../inside-orbit-menu-consts/inside-orbit-menu-text.consts";



export class ClearLocalStorageMenuAction implements IInsideOrbitMenuActionInterface {
    constructor(private services: IInsideOrbitMenuServices) {
    }

    get text() {
        return CLEAR_LOCAL_STORAGE;
    }

    execute = () => {
        window['CGP'].clearLocalStorage();
    }
}